import React, { Component } from 'react';

import {Card} from 'material-ui/Card';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';

import * as EmailValidator from 'email-validator';

import Config from '../../conf';
import {CustomerDetails as styles} from './form.css';

class Details extends Component {

  constructor(props) {
    super(props);

    this.state = {
      dialogOpen: false
    };

    this.keyTyped = this.keyTyped.bind(this);
    this.nextDisabled = this.nextDisabled.bind(this);
    this.tryNext = this.tryNext.bind(this);
    this.onFpMemberChange = this.onFpMemberChange.bind(this);
    this.handleDialogClose = this.handleDialogClose.bind(this);
  }

  handleDialogClose(member) {
    this.setState({
      dialogOpen: false
    });
    if (member) {
      this.props.setFpMember(true);
    }
  }

  onFpMemberChange(evt, idx, val) {
    // if "yes" selected (and the dropdown wasn't already "yes"), show popup dialog
    if (val) {
      if (!this.props.details.fpMember) {
        // show dialog
        this.setState({
          dialogOpen: true
        });
      }
      return;
    }
    // selected "no", no popup required
    this.props.setFpMember(false);
  }

  nextDisabled() {
    let ret = (this.props.details.name &&  this.props.details.name !== '') && 
                (this.props.details.email && this.props.details.email !== '') &&
                (this.props.details.phone && this.props.details.phone !== '');
    
    if (Config.CLIENT_NAME === "FleetPlus" && this.props.details.fpMember === null) ret = false;
    return !ret;
  }

  tryNext() {
    if (!EmailValidator.validate(this.props.details.email)) {
      // invalid email address
      this.props.updateField('emailError', 'Please enter a valid email address');
    } else if (!this.props.details.phone.replace(/[\s]/g, '').match(/^[0-9]{10}$/)) {
      this.props.updateField('phoneError', 'Please enter a valid mobile number');
    } else {
      // everything valid, move onto next step
      this.props.next();
    } 
  }

  keyTyped(field, value) {
    this.props.setHasError(field, false);
    this.props.updateField(field, value);
  }

  render() {
    const actions = [
      <RaisedButton
        style={styles.dialogButton}
        label="OK"
        primary={true}
        keyboardFocused={true}
        onTouchTap={() => this.handleDialogClose(true)}
      />,
      <RaisedButton
        style={styles.dialogButton}
        label="Cancel"
        onTouchTap={() => this.handleDialogClose(false)}
      />
    ];

    return (
      <div>
        <Dialog
          title={Config.CLIENT_NAME}
          actions={actions}
          modal={true}
          open={this.state.dialogOpen}
          className="counteract-zoom"
        >
          {Config.CLIENT_NAME} membership details will be validated before your booking is confirmed.
        </Dialog>

        <Card style={styles.card}>
          <h2 style={styles.title}>Please fill in your personal details</h2>
          <div style={styles.wrapper}>
            <TextField
              style={styles.field}
              hintStyle={styles.hintStyle}
              hintText={'Full Name'}
              floatingLabelText={this.props.details.name ? 'Full Name' : ' '}
              floatingLabelFixed={true}
              inputStyle={styles.inputStyle}
              value={this.props.details.name}
              onChange={(evt) => this.keyTyped('name', evt.target.value)}
              errorText={this.props.details.nameError ? 'Please fill in this field' : ''}
              maxLength={64}
            />
            <TextField
              style={styles.field}
              hintStyle={styles.hintStyle}
              inputStyle={styles.inputStyle}
              hintText={'Email Address'}
              floatingLabelText={this.props.details.email ? 'Email Address' : ' '}
              floatingLabelFixed={true}
              value={this.props.details.email}
              onChange={(evt) => this.keyTyped('email', evt.target.value)}
              errorText={this.props.details.emailError ? this.props.details.emailError : ''}
              maxLength={64}
            />
            <TextField
              style={styles.field}
              hintStyle={styles.hintStyle}
              inputStyle={styles.inputStyle}
              hintText={'Mobile Number'}
              floatingLabelText={this.props.details.phone ? 'Mobile Number' : ' '}
              floatingLabelFixed={true}
              value={this.props.details.phone}
              onChange={(evt) => this.keyTyped('phone', evt.target.value.replace(/[^0-9\s]/g, ''))}
              errorText={this.props.details.phoneError ? this.props.details.phoneError : ''}
              maxLength={20}
            />
            
            { Config.CLIENT_NAME === "FleetPlus" &&
              <div>
                <TextField
                  style={styles.field}
                  hintStyle={styles.hintStyle}
                  inputStyle={styles.inputStyle}
                  hintText={'Company'}
                  floatingLabelText={this.props.details.phone ? 'Company' : ' '}
                  floatingLabelFixed={true}
                  value={this.props.details.company}
                  onChange={(evt) => this.keyTyped('company', evt.target.value)}
                  errorText={this.props.details.companyError ? this.props.details.companyError : ''}
                  maxLength={20}
                />
                <p style={{ paddingTop: 15 }}>Are you an existing {Config.CLIENT_NAME} member?</p>
                <SelectField
                  style={styles.field}
                  floatingLabelText=""
                  value={this.props.details.fpMember}
                  onChange={this.onFpMemberChange}
                >
                  <MenuItem value={true} primaryText="Yes" />
                  <MenuItem value={false} primaryText="No" />
                </SelectField>
              </div>
            }
          </div>

          <RaisedButton style={styles.button}
            label="Back" primary={true} onClick={this.props.back} />
          <RaisedButton style={styles.button} disabled={this.nextDisabled()}
            label="Next" primary={true} onClick={this.props.next} />
        </Card>
      </div>
    );
  }
}

export default Details;



// WEBPACK FOOTER //
// ./src/app/components/form/CustomerDetails.js